import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { OptionsList, OptionsListGridItem } from 'src/app/models/optionsList.model';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { SaveNameListComponent } from 'src/app/features/create-questionnaire-page/component/question-form/components/save-name-list/save-name-list.component';
import { OptionsListApiService } from 'src/app/features/collections/services/options-list-api.service';
import { CollectionListsStore } from '../../store/lists-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { ToggleComponent } from 'src/app/shared/components/toggle/toggle.component';
import { QueDatePipe } from 'src/app/pipes/date.pipe';

@Component({
    selector: 'que-list-collections-item',
    templateUrl: './list-collections-item.component.html',
    styleUrls: ['./list-collections-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatButtonModule, MatMenuModule, TranslateDirective, TranslatePipe, OverlayModule, ToggleComponent, QueDatePipe]
})
export class ListCollectionsItemComponent implements OnInit {
  @Input() listCollectionItem?: OptionsListGridItem;
  @Input() isLast = false;
  
  @ViewChild('trigger') trigger!: ElementRef;
  isMenuOpen = false;
  #dialog = inject(MatDialog);
  #optionsListApiService = inject(OptionsListApiService);
  #listStore = inject(CollectionListsStore);
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  isDisplayNotActiveItems$ = toSignal(this.#manipulationsToolbarStore.isDisplayNotActiveItems$);

  readonly positonArea = [{
    originX: 'center',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'top',
  }] as ConnectedPosition[];
  ngOnInit(): void {
  }

  openMenu(ev: Event) {
    ev.stopPropagation();
    const triggerRect = this.trigger.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    // Check if the menu would open out of the viewport
    if (triggerRect.bottom + 200 > viewportHeight) { // assuming 200px height for the menu
      this.positonArea[0].overlayY = 'bottom';
    } else {
      this.positonArea[0].overlayY = 'top';
    }
    this.isMenuOpen = true;
  }
  edit() {
    this.isMenuOpen = false;
    this.#optionsListApiService.getListWithItemById(this.listCollectionItem?.guid??"").subscribe(list => {
      this.#dialog.open(SaveNameListComponent,
        {
          data: { withItems: true, editList: list },
          autoFocus: false
        })
        .afterClosed().subscribe((result) => {
          if (result) {
            const list = result;
            this.#listStore.updateList(list);
          }
        })
    })
  }
  changeStatus() {
    this.isMenuOpen = false;
    if (this.listCollectionItem) {
      this.#listStore.changeListStatus(this.listCollectionItem);
    }
  }
  duplicate() {
    this.isMenuOpen = false;
    this.#dialog.open(SaveNameListComponent,
      {
        autoFocus: false,
        data: {
          isDuplicateListPopup: true,
          listName: this.listCollectionItem?.name
        }
      }
    ).afterClosed()
      .subscribe((resultFromPopUp: string) => {
        if (this.listCollectionItem && resultFromPopUp) {
          this.#listStore.duplicateList({ guid: this.listCollectionItem?.guid, name: resultFromPopUp });
        }
      })
  }
}
